module.exports = __webpack_public_path__ + "ebd27c2acbc1115d8757c2d5efeaa09d.png";